import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Package, AlertTriangle, History as HistoryIcon } from 'lucide-react';
import { formatDate, getStatusBadge } from './utils';

export const HistorySection = ({ history }) => (
  <div className="space-y-4">
    <div className="flex items-center gap-3">
      <HistoryIcon className="w-6 h-6" />
      <h2 className="text-2xl font-heading font-bold">Historique des Affectations</h2>
      <Badge variant="outline" className="text-base">{history.length} total</Badge>
    </div>

    {history.length > 0 ? (
      <div className="space-y-3">
        {history.map((assignment) => (
          <Card key={assignment.id} data-testid={`history-item-${assignment.id}`} className="hover:shadow-md transition-shadow duration-200">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  {assignment.tool?.photo ? (
                    <img src={assignment.tool.photo} alt={assignment.tool.name} className="w-10 h-10 object-contain bg-muted rounded-lg" />
                  ) : (
                    <div className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
                      <Package className="w-5 h-5 text-muted-foreground" />
                    </div>
                  )}
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="font-medium">{assignment.tool?.name}</span>
                      <span className="text-sm text-muted-foreground">({assignment.tool?.type})</span>
                    </div>
                    <div className="text-xs font-mono text-muted-foreground">N° {assignment.tool?.article_number || 'N/A'}</div>
                    <div className="text-sm text-muted-foreground">
                      {formatDate(assignment.assigned_date)}
                      {assignment.returned_date && <> → {formatDate(assignment.returned_date)}</>}
                    </div>
                    {assignment.replacement_reason && (
                      <div className="text-xs text-destructive mt-1 flex items-center gap-1">
                        <AlertTriangle className="w-3 h-3" /> Raison: {assignment.replacement_reason}
                      </div>
                    )}
                  </div>
                </div>
                {getStatusBadge(assignment.status)}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    ) : (
      <Card className="border-2 border-dashed">
        <CardContent className="flex flex-col items-center justify-center py-12">
          <HistoryIcon className="w-12 h-12 text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Aucun historique disponible</p>
        </CardContent>
      </Card>
    )}
  </div>
);
